import React from 'react';
import { Alert, message } from 'antd';

type ToastContent = string | JSX.Element | JSX.Element[];

interface FullToastOptions {
  type: 'error'|'warning'|'success';
  title?: string;
  message: ToastContent;
  duration?: number;
}

interface ToastOptions extends Omit<FullToastOptions, 'type' | 'message'> {}

let counter = 0;

function showAsAlert(options:FullToastOptions) {
  let key = counter++;

  message.open({
    key,
    duration: options.duration || 3,
    content: (
      <Alert
        type={options.type}
        message={options.title}
        description={options.message}
        closable
        onClose={() => message.destroy(key)}
      />
    )
  });
}

function showAsMessage(options:FullToastOptions) {
  let key = counter++;

  message.open({
    key,
    type: options.type,
    duration: options.duration || 3,
    content: (<>
      {options.message}
      <a style={{ marginLeft: 8 }} onClick={() => message.destroy(key)}>✕</a>
    </>),
  });
}

function show(options:FullToastOptions) {
  return options.title
    ? showAsAlert(options)
    : showAsMessage(options);
}

const toastFns = {
  showSuccess: (message:ToastContent, options:ToastOptions={}) => show({ ...options, message, type: 'success' }),
  showWarning: (message:ToastContent, options:ToastOptions={}) => show({ ...options, message, type: 'warning' }),
  showError: (message:ToastContent, options:ToastOptions={}) => show({ ...options, message, type: 'error' }),
};

export default () => toastFns;
